import * as React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { SvgSprite } from "../components/global/SvgSprite";
import { NotificationProvider } from "../components/NotificationContext";
import "../scss/app.scss";


if (process.env.NODE_ENV === 'development' && process.env.HOT_RELOAD_DISABLE === '1') { //TODO remove
  if (module.hot) {
    module.hot.addStatusHandler(status => {
      if (status === "apply") window.location.reload();
    });
  }
}

const Layout = ({ children, translations }) => {
  return (
    <NotificationProvider>
      <Header translations={translations} />
      <main>{children}</main>
      <Footer />
      <SvgSprite />
    </NotificationProvider>
  );
};

export default Layout;
